import { useI18n } from 'contexts/i18n';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCartService } from 'services';
import { displayNotification } from 'utils';

export const useDsoEmptyCart = () => {
  const i18n = useI18n();
  const queryClient = useQueryClient();
  return useMutation(
    () => {
      return dsoCartService.dsoEmptyCart();
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
      },
      onError: () => {
        displayNotification(i18n['Failed to empty Cart!'], 'danger');
      },
    }
  );
};
